import { useContext, useEffect, useState } from "react";

import { TeamContext, UserContext } from "../../../../context";
import { DeckMolecule } from "../../../molecules";
import { ArrowNotification, PinkNotification } from "../../../atoms";
import { useSound } from "../../../../hooks";
import { ICard, IPlayer } from "../../../../interfaces";
import DilemmaOwnerAnouncementText from "../../DilemmaOwnerAnouncement/DilemmaOwnerAnouncementText";
import { useTranslation } from "react-i18next";

type challengeCardType = "questionCard" | "actionCard";

interface IRenderInitialDisplay {
    challengeCard: any;
    comfirmActionCardParent: (fieldName: challengeCardType, card: ICard) => void;
}


const RenderInitialDisplay: React.FC<IRenderInitialDisplay | undefined> = ({ challengeCard, comfirmActionCardParent }) => {
    const { t } = useTranslation();
    const { game } = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    const [isActionDeckHovered, setIsActionDeckHovered] = useState(false);
    const [isQuestionDeckHovered, setIsQuestionDeckHovered] = useState(false);  
    const dilemmaOwner = game?.players.find((player: IPlayer) => { return game.gameInfo.currentPlayerEmail === player.email })
    const isTheUserDilemaOwner = userData?.email === game?.gameInfo.currentPlayerEmail;
    const numberOfSolvedDilemmas: number = game?.gameInfo.challengeScore || 0;
    const dilemmaOwnerNickname = dilemmaOwner?.nickname || "";
    const solutionOwnerSubTitleTextLine = (numberOfSolvedDilemmas > 1) ? t("pleaseWaitForTheQuestionOrActionToBeChosenText") : t("pleaseWaitForTheQuestionToBeChosenText");
    const dilemmaOwnerSubTitleTextLine = (numberOfSolvedDilemmas > 1) ? t("pleaseChooseActionOrQuestionText") : t("pleaseChooseAQuestionByDoubleClickingText");
    
    const {playSound} = useSound();

    useEffect (() => {
        const isCardHovered = isActionDeckHovered || isQuestionDeckHovered;
        if(isCardHovered) 
            playSound("/sounds/ItemHover.mp3");

    },[isActionDeckHovered, isQuestionDeckHovered, playSound]);

    useEffect(() => {
        playSound("/sounds/PositiveAlert3.mp3");
      
    },[playSound]);

    const notificationActionCard = () => {
        return (
            <div style={{ zIndex: 5, position: 'relative', left: '-15px', paddingTop: '15%' }}>
                <div style={{position: "relative", left: "-15vw" }}>
                     <ArrowNotification title={t("actionCardsText")} width="18vw" text={t("energizingTasksThatNeedToBeCompletedText")} type="left" />
                </div>
            </div>
        );
    }

    if (challengeCard.actionCard || challengeCard.questionCard) {
        return (
            <div className="absolute_whole_screen" >
                <div className="render_initial_display">
                    <DilemmaOwnerAnouncementText upperText={dilemmaOwnerNickname + ' ' + t("isTheDilemmaOwnerText")} lowerText={isTheUserDilemaOwner ? dilemmaOwnerSubTitleTextLine : solutionOwnerSubTitleTextLine} componentStyle="dilemma" isArrowShown={isTheUserDilemaOwner} />

                    <div className="render_initial_dispaly_challenge_cards">
                        <div className="challenge_decks_wrapper">


                            <div className="animation_ripple animation_ripple_delay_8">
                                <div className="challenge_deck_wrapper challenge_deck_image"
                                    onMouseEnter={() => setIsQuestionDeckHovered(true)}
                                    onMouseLeave={() => setIsQuestionDeckHovered(false)}
                                >
                                    <div className="challenge_decks_notification">
                                        <div className="action_notification_left">
                                            {isQuestionDeckHovered && 
                                            <PinkNotification notificationWidthVW={20} notificationRenderingSide="left" text={t("workRelatedDilemmasText")} moveFromTop={20} />}
                                        </div>
                                    </div>
                                    <DeckMolecule
                                        type="question"
                                        onDraw={() => comfirmActionCardParent("questionCard", challengeCard.questionCard!)}
                                    />
                                </div>
                            </div>

                            
                            {numberOfSolvedDilemmas > 1 &&
                                <div className="animation_ripple animation_ripple_delay_10">
                                    <div className="challenge_deck_wrapper action_deck_image"
                                        onMouseEnter={() => setIsActionDeckHovered(true)}
                                        onMouseLeave={() => setIsActionDeckHovered(false)}
                                    >
                                        <div className="challenge_decks_notification">
                                            <div className="action_notification_right">
                                                {isActionDeckHovered && notificationActionCard()}
                                            </div>
                                        </div>
                                        <DeckMolecule
                                            type="action"
                                            onDraw={() => comfirmActionCardParent("actionCard", challengeCard.actionCard!)}
                                        />

                                    </div>
                                </div>
                            }

                           
                        </div>

                    </div>
                    <div className="render_initial_dispaly_footer"></div>
                </div>
            </div>
        );
    } 
    
    return (<div></div>);    
}

export default RenderInitialDisplay;
